import { matchAttribute } from '../attributes/matchAttribute';

export const getSize = (variant: GQL.IProductVariant | GQL.IOrderItem, sizeAttributes: Array<GQL.IAttribute>, language: string) => {
  const sizeAttribute = matchAttribute(variant, sizeAttributes);
  if (sizeAttribute == undefined) {
    return undefined;
  }

  const sizeValueId = (variant.definition || {})[ sizeAttribute.id ];
  if (sizeValueId == undefined) {
    return undefined;
  }

  const sizeValue = (sizeAttribute.values || []).find(v => v.id == sizeValueId);
  if (sizeValue == undefined) {
    return undefined;
  }

  if (typeof sizeValue.value[ language ] === 'object') {
    if (Array.isArray(sizeAttribute.definition)) {
      const sizesVariants = sizeAttribute.definition.map((sv) => sv.value);

      return {
        sizesVariants,
        availableSizes: sizeValue.value[ language ],
        toString: () => sizeValue.value[ language ][ sizesVariants[ 0 ] ]
      };
    }

    const keys = Object.keys(sizeValue.value[ language ]);
    return {
      sizeVariants: [],
      availableSizes: sizeValue.value[ language ],
      toString: () => sizeValue.value[ language ]
    };
  } else if (sizeValue.value[ language ] === undefined) {

    // hodnota value[language] není zadána
    // fuj, nesystemový fix
    return {
      sizeVariants: [],
      availableSizes: sizeValue.title,
      toString: () => sizeValue.title
    };
  }

  return {
    sizeVariants: [],
    availableSizes: sizeValue.value[ language ],
    toString: () => sizeValue.value[ language ]
  };
};



// WEBPACK FOOTER //
// ./src/helpers/products/getSize.ts